export default "__VITE_ASSET__BJNUU4Lp__"